<template>
  <div id="app">
    <nav-bar />
    <toast v-if="this.toasts" />
    <main role="main">
      <router-view />
    </main>
    <common-footer />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import CommonFooter from "./components/global/CommonFooter";
import NavBar from "./components/global/NavBar";
import Toast from "./components/global/Toast";

export default {
  name: "App",
  components: {
    CommonFooter,
    NavBar,
    Toast,
  },
  created() {
    if (!this.myProfile.userId) {
      this.getMyProfile();
    }
  },
  computed: {
    ...mapGetters(["showBackdrop", "myProfile", "toasts"]),
  },
  methods: {
    ...mapActions(["getMyProfile"]),
  },
};
</script>

<style lang="scss">
@use "../sass/main.scss";
</style>
